// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2tmyi","title":"Info_title__Pl6hE","selects":"Info_selects__HsVJ3","requiredAsterisk":"Info_requiredAsterisk__1aRhn"};